import React from 'react'
import BookingButton from '../booking/BookingButton'

const BannerImage = () => (
  <div>
    <section className="hero">
      <div className="hero-body vertical-center-desktop home-page-body">
        <div className="container has-text-centered">
          <h1 className="subtitle is-2">Your car needs to go to the shop. You don't.</h1>
          <h1 className="subtitle is-5">
            We make car servicing easy, from start to finish. We bring the car to and back from the
            shop, so you get your valuable time back.{' '}
          </h1>
          <div className="checkmark-container">
            <div>
              <img src="assets/images/checkmarkedbox.svg" aria-hidden alt="Offers" />{' '}
              <b className="checkmark">Trusted Advisor</b>
            </div>
            <div>
              <img src="assets/images/checkmarkedbox.svg" aria-hidden alt="Offers" />{' '}
              <b className="checkmark">Car Pick-up & Drop-off</b>
            </div>
            <div>
              <img src="assets/images/checkmarkedbox.svg" aria-hidden alt="Offers" />{' '}
              <b className="checkmark">No Upsells</b>
            </div>
          </div>
          <BookingButton
            id="request_service_banner_button"
            type="primary"
            className="orangeButton"
            size="large"
          />
        </div>
      </div>
    </section>
    <div className="hero-image-section">
      <img
        src="assets/images/bannergraphic.svg"
        className="hero-image"
        aria-hidden
        alt="Automech saves time"
      />
    </div>
  </div>
)

export default BannerImage



// WEBPACK FOOTER //
// ./src/components/home/BannerImage.js